import { render, staticRenderFns } from "./UploadCert.vue?vue&type=template&id=5de07e2c&scoped=true&"
import script from "./UploadCert.vue?vue&type=script&lang=js&"
export * from "./UploadCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de07e2c",
  null
  
)

export default component.exports